import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import type { Comment } from "@/types/generated";
import { Button } from "../ui/button";
import { MessageCircle } from "lucide-react";
import { CommentInput } from "../CommentInput";
import { CommentsList } from "../CommentsList";

interface EventCommentsCardProps {
  trackEventId: number;
  comments: Comment[];
}

export function EventCommentsCard({
  trackEventId,
  comments,
}: EventCommentsCardProps) {
  const [showInput, setShowInput] = useState(false);

  return (
    <Card className="mb-6">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-base">Comments</CardTitle>
          <Button
            onClick={() => setShowInput(!showInput)}
            variant="ghost"
            size="sm"
          >
            <MessageCircle className="w-4 h-4 mr-2" />
            Add Comment
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        {showInput && (
          <div className="mb-4 pb-4 border-b">
            <CommentInput
              commentableType="TrackEvent"
              commentableId={trackEventId}
              onCancel={() => setShowInput(false)}
              autoFocus
            />
          </div>
        )}
        {comments.length > 0 ? (
          <CommentsList comments={comments} maxComments={999} />
        ) : (
          <div className="flex flex-col gap-2 items-center">
            <p className="text-sm text-muted-foreground text-center py-8">
              No comments yet. Be the first to comment!
            </p>
            {!showInput && (
              <Button
                onClick={() => setShowInput(true)}
                className="w-fit self-center"
              >
                Add coment
              </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
